import React from 'react';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => <>{/* Because of the system dashboard, there can never be no dashboard */}</>;
